import React, { useState, useEffect } from 'react'
import { Translates } from '@/services/repository/i18n'

export interface PageQuery {
  pageNumber: number
  totalPages: number
  pageSize: number
}

export type onChange = (q: PageQuery) => void

export interface PaginationParams {
  translates: Translates
  pageQuery: PageQuery
  onChange?: onChange
}

export const Pagination = (params: PaginationParams) => {
  const { translates } = params
  const correctPageNumber = (pageNumber: number, totalPages: number) => pageNumber < 1 ? 1 : pageNumber < params.pageQuery.totalPages ? pageNumber : totalPages
  const [pageQuery, setPageQuery] = useState<PageQuery>();

  useEffect(() => {
    setPageQuery({
      ...params.pageQuery,
      pageNumber: correctPageNumber(params.pageQuery.pageNumber, params.pageQuery.totalPages),
    });
  }, [params.pageQuery]);

  if(pageQuery===undefined) {
    return
  }

  const prev = () => {
    updatePageNumber(pageQuery.pageNumber > 1 ? pageQuery.pageNumber - 1 : pageQuery.pageNumber)
  }

  const next = () => {
    updatePageNumber(pageQuery.pageNumber < pageQuery.totalPages ? pageQuery.pageNumber + 1 : pageQuery.pageNumber)
  }

  const updatePageNumber = (value: number) => {
    if (Number.isNaN(value)) {
      return
    }
    value = correctPageNumber(value, pageQuery.totalPages)
    if (pageQuery.pageNumber === value) {
      return
    }
    const newQuery = {
      ...pageQuery,
      pageNumber: value
    }
    setPageQuery(newQuery)
    params.onChange && params.onChange(newQuery)
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if(event.target.value==='') {
      setPageQuery({
        ...pageQuery,
        pageNumber: 0
      })
      return
    }
    updatePageNumber(parseInt(event.target.value))
  };

  const handleBlur = (event: React.ChangeEvent<HTMLInputElement>): void => {
    updatePageNumber(parseInt(event.target.value))
  };

  if (pageQuery.totalPages === 0) {
    return
  }

  return <div className='pagination'>
    <div
      className={'prev ' + (pageQuery.pageNumber < 2 ? 'inactive' : '')} onClick={() => prev()}>
      <i className='svgfont-left-circle' title={translates.for('elements.pagination.prev')} />
    </div>
    <div className='input'>
      <input
        type='text'
        value={pageQuery.pageNumber}
        placeholder='1'
        onChange={handleChange}
        readOnly={pageQuery.totalPages === 1}
        onBlur={handleBlur}
      />
    </div>
    <div className='separator'>
      /
    </div>
    <div className='total-pages'>
      <input
        type='text'
        value={pageQuery.totalPages}
        placeholder='1'
        readOnly={true}
      />
    </div>
    <div className={'next ' + (pageQuery.totalPages === pageQuery.pageNumber ? 'inactive' : '')} onClick={() => next()}>
      <i className='svgfont-right-circle' title={translates.for('elements.pagination.next')} />
    </div>
  </div>
}
